module.exports = __webpack_public_path__ + "static/media/course.ea5f1434.svg";